export const AGENT_MODE_STATE = "vertesia.adt.agentModeState"
export const AUTO_SEARCH_STATE = "vertesia.adt.autoSearchState"
export const LAST_DISPLAYED_VIEW = "vertesia.adt.lastDisplayedView"
export const LAST_PANEL_STATE = "vertesia.adt.lastPanelState"
export const RENDITION_ID = "vertesia.adt.renditionId"
